module.exports = __webpack_public_path__ + "ilkka_logo_white_h25-cfc54b023a61f1b4ac97.png";